import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-cart-quick-order',
  templateUrl: './cart-quick-order.component.html',
  styleUrls: ['./cart-quick-order.component.scss'],
  standalone: false,
})
export class CartQuickOrderComponent implements OnInit, OnDestroy {
  showSrp = false;
  srpSubscription$: Subscription;
  constructor(
    private routingService: RoutingService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private languageService: ShimanoLanguageService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });
  }
  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }
  goToQuickOrder() {
    this.routingService.go({ cxRoute: 'quickOrderPage' });
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
  }
}
